import React from "react";
import { Button } from "@racoon/ui";
import { useTypedT, Namespace } from "@racoon/i18n";
import { MapVisibilityStore, useMapVisible } from "../model/map-visibility";
import { IcRoutes } from "@racoon/icons";

interface AssignRouteHeaderProps {
  title: string;
  mapVisibility: MapVisibilityStore;
}

// Modal header: title plus the map toggle. Rendered through ModalProvider's
// `title` slot, so it also carries the row layout the header itself lacks.
export const AssignRouteHeader: React.FC<AssignRouteHeaderProps> = ({ title, mapVisibility }) => {
  const t = useTypedT(Namespace.Routes);
  const isMapVisible = useMapVisible(mapVisibility);

  return (
    <span className="flex w-full items-center justify-between gap-4">
      {title}
      {/* The map panel itself only exists from lg up — below that there is
          nothing to toggle. */}
      <Button
        variant="ghost"
        size="sm"
        className="text-brand-blue hidden gap-1 font-medium !text-sm lg:inline-flex"
        onClick={mapVisibility.toggle}
      >
        <IcRoutes className="h-4 w-4 text-brand-blue" />
        {isMapVisible ? t("hideMap") : t("showMap")}
      </Button>
    </span>
  );
};
